import { EnumOption } from "./enum-option"

export const EmailActiveStatus = {
    Active: 0,
    InActive: 1,

}

export const EmailStatusList: EnumOption[] = [
    { value: EmailActiveStatus.Active, label: 'Active' },
    { value: EmailActiveStatus.InActive, label: 'InActive' },
]
